import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card-header border-0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder" }, "Credit Balance")
], -1)
const _hoisted_3 = { class: "card-toolbar" }
const _hoisted_4 = {
  href: "#",
  class: "btn btn-sm btn-flex btn-light-primary",
  "data-bs-toggle": "modal",
  "data-bs-target": "#kt_modal_adjust_balance"
}
const _hoisted_5 = { class: "svg-icon svg-icon-3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "card-body pt-0" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder fs-2" }, [
    /*#__PURE__*/_createTextVNode(" $32,487.57 "),
    /*#__PURE__*/_createElementVNode("span", { class: "text-muted fs-4 fw-bold" }, "USD"),
    /*#__PURE__*/_createElementVNode("div", { class: "fs-7 fw-normal text-muted" }, " Balance will increase the amount due on the customer's next invoice. ")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`card pt-4 ${_ctx.cardClasses}`)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("a", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, [
            _createVNode(_component_inline_svg, { src: "/media/icons/duotune/art/art005.svg" })
          ]),
          _createTextVNode(" Adjust Balance ")
        ])
      ])
    ]),
    _hoisted_6
  ], 2))
}